import React from "react";
import Text from "../atoms/Text";
import { formatCurrency } from "./ProfileShared";

export default function CartProfile({
  cartProducts,
  onUpdateCartQuantity,
  onRemoveFromCart,
}) {
  if (cartProducts.length === 0) {
    return (
      <div
        style={{
          border: "1px solid var(--gray1)",
          borderRadius: "8px",
          backgroundColor: "var(--white)",
          padding: "24px",
        }}
      >
        <Text size="px24" weight="w500" color="gray9">
          Shopping Cart
        </Text>
        <Text size="px16" weight="w400" color="gray5" extraStyles={{ marginTop: "16px" }}>
          Your cart is empty.
        </Text>
      </div>
    );
  }

  return (
    <div
      className="cart-profile"
      style={{
        border: "1px solid var(--gray1)",
        borderRadius: "8px",
        backgroundColor: "var(--white)",
        overflow: "hidden",
      }}
    >
      <div
        className="cart-profile-head"
        style={{
          display: "grid",
          gridTemplateColumns: "2.2fr 0.7fr 0.7fr 0.7fr 48px",
          padding: "18px 24px",
          backgroundColor: "var(--white)",
          borderBottom: "1px solid var(--gray1)",
        }}
      >
        {["Product", "Price", "Quantity", "Subtotal", ""].map((heading) => (
          <Text
            key={heading || "actions"}
            size="px12"
            weight="w500"
            color="gray5"
            extraStyles={{ textTransform: "uppercase", textAlign: "start" }}
          >
            {heading}
          </Text>
        ))}
      </div>

      {cartProducts.map((item) => (
        <div
          className="cart-profile-row"
          key={item.id}
          style={{
            display: "grid",
            gridTemplateColumns: "2.2fr 0.7fr 0.7fr 0.7fr 48px",
            padding: "24px",
            borderTop: "1px solid var(--gray05)",
            alignItems: "center",
            columnGap: "16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "20px", minWidth: 0 }}>
            <img
              src={item.image}
              alt={item.name}
              style={{ width: "80px", height: "80px", objectFit: "contain", flexShrink: 0 }}
            />
            <Text size="px20" weight="w400" color="gray9">
              {item.name}
            </Text>
          </div>

          <Text size="px20" weight="w400" color="gray9">
            {formatCurrency(item.price)}
          </Text>

          <div
            style={{
              width: "120px",
              height: "50px",
              border: "1px solid var(--gray1)",
              borderRadius: "999px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 8px",
            }}
          >
            <button
              type="button"
              onClick={() => onUpdateCartQuantity(item.id, item.quantity - 1)}
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "var(--gray05)",
                color: "var(--gray5)",
                fontSize: "24px",
                lineHeight: 1,
                cursor: "pointer",
              }}
            >
              -
            </button>
            <Text size="px18" weight="w500" color="gray9">
              {item.quantity}
            </Text>
            <button
              type="button"
              onClick={() => onUpdateCartQuantity(item.id, item.quantity + 1)}
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "var(--gray05)",
                color: "var(--gray5)",
                fontSize: "24px",
                lineHeight: 1,
                cursor: "pointer",
              }}
            >
              +
            </button>
          </div>

          <Text size="px20" weight="w500" color="gray9">
            {formatCurrency(item.price * item.quantity)}
          </Text>

          <button
            type="button"
            onClick={() => onRemoveFromCart(item.id)}
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              border: "1px solid var(--gray2)",
              backgroundColor: "var(--white)",
              color: "var(--gray4)",
              fontSize: "18px",
              lineHeight: 1,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
